import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const setMeta = (selector: string, content: string) => {
  const el = document.querySelector(selector);
  if (el) el.setAttribute('content', content);
};

export const useMetaTags = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const description = t('seo.description');
    const keywords = t('seo.keywords');

    document.documentElement.lang = i18n.language;
    setMeta('meta[name="description"]', description);
    setMeta('meta[name="keywords"]', keywords);
    setMeta('meta[property="og:description"]', description);
    setMeta('meta[property="twitter:description"]', description);
  }, [t, i18n.language]);
};
